import { useRestoreModalFocus } from '../../../hooks/useRestoreModalFocus';

export const RestoreModalFocusMount = (): null => {
  useRestoreModalFocus();

  return null;
};
